import app from '@/main'

async function dialogSetRelationship ({ userId, relationship }) {
  return await app.wsp.sendRequest({
    data: {
      userId: userId,
      relationship: relationship
    },
    method: 'dialog.setRelationship'
  })
}

export default dialogSetRelationship